import { units } from '@ui/css';
import { combineTokens } from '@utils/css';

const tokens = combineTokens("--show-for", {
  from: units.px(0),
  to: units.px(100000)
});

// We need to be able to show/hide the container / its children based on dynamic
// media queries.
// As media queries does not support css-variables we instead 'hack' this using
// variables as logic gates as follows:
//
//  1) If the current viewport is greater than the from-value we set
//  --matches-from to 1px, otherwise it will be 0px.
//
//  2) If the current viewport is greater than the to-value we set
//  --not-matches-to to 1px, otherwise it will be 0px.
//
//  3) now, we flip --not-matches-to such that --matches-to will be 1px if the
//  viewport is smaller than the top of the breakpoint.
//
//  4) now, we combine these to determine if the current viewport matches the
//  breakpoint by ensuring that both --matches-from and --matches-to must be 1px
//  in order for our --matches value to become very large, effectively showing
// its content
const ssrContainer = "_ecs1l93of4";

export { ssrContainer, tokens };
import "./show-for.style.linaria.module.css";
//# sourceMappingURL=show-for.style.js.map
